import React from 'react';

export interface CatalogSkeletonProps {
  count?: number;
}

export const CatalogSkeleton: React.FC<CatalogSkeletonProps> = ({ count = 12 }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-5 gap-x-3 md:gap-x-5 gap-y-10 md:gap-y-16">
      {Array.from({ length: count }).map((_, idx) => {
        // Alternate a 2-col bundle skeleton every 6 cards for visual rhythm
        const isWide = idx % 6 === 2;
        const colSpan = isWide ? 'col-span-2' : 'col-span-1';
        const ratio = isWide ? 'card-ratio-2' : 'card-ratio-1';

        return (
          <div key={idx} className={`pt-6 md:pt-8 flex flex-col ${colSpan}`}>
            <div
              className={`relative flex-1 flex flex-col justify-between rounded-2xl md:rounded-[22px] bg-[#0d1b2e]/80 border border-white/10 p-3 md:p-4 animate-pulse overflow-hidden ${ratio}`}
            >
              {/* Badge placeholder */}
              <div className="w-16 h-4 bg-white/10 rounded-full" />

              {/* Character center circle shimmer */}
              <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                <div className="w-24 h-24 md:w-32 md:h-32 bg-white/5 rounded-full" />
              </div>

              {/* Bottom text placeholder */}
              <div className="relative z-10 space-y-2 mt-auto">
                <div className="w-3/4 h-4 bg-white/15 rounded" />
                <div className="flex items-center justify-between pt-1">
                  <div className="flex items-center gap-1.5">
                    <div className="w-4 h-4 bg-yellow-400/30 rounded-full" />
                    <div className="w-16 h-4 bg-white/20 rounded" />
                  </div>
                  <div className="w-7 h-7 bg-white/10 rounded-full" />
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CatalogSkeleton;
